import { memo } from 'react';
import { ActuatorTypes } from 'src/actuators/user-input/calculations/constants';
import { DamperType, UserInput } from 'src/actuators/user-input/types';
import { LocalesEnum, RegionsEnum } from 'src/generated/operations';
import { getActuatorBreadcrumbValues } from '../hooks/getActuatorBreadcrumbValues';

type Props = {
    region: RegionsEnum;
    state: UserInput;
    locale: LocalesEnum;
    selectedActuatorType: ActuatorTypes;
}

export const ActuatorBreadcrumbValue = memo(({ region, state, locale, selectedActuatorType }: Props) => {
    const {
        damper: [, damperValue],
        area: [, areaValue],
        diameter: [, diameterValue],
        blade: [, bladeValue],
        roundDumper: [, roundDumperValue],
        airflow: [airflowLabel, airflowValue],
        damperRequired: [, damperRequiredValue],
        safety: [, safetyValue],
    } = getActuatorBreadcrumbValues({ region, state, locale, selectedActuatorType });

    const airflowLabelAndValue = (
        <>
            {airflowLabel} {airflowValue}
        </>
    );

    const rectangularAmResults = [damperValue, areaValue, bladeValue, airflowLabelAndValue, damperRequiredValue];
    const roundAmResults = [damperValue, areaValue, airflowLabelAndValue, damperRequiredValue];
    const rectangularEuResults = [damperValue, areaValue, bladeValue, safetyValue];
    const roundEuResults = [damperValue, diameterValue, roundDumperValue, safetyValue];

    const results = {
        [DamperType.Rectangular]: region === RegionsEnum.Am ? rectangularAmResults : rectangularEuResults,
        [DamperType.Round]: region === RegionsEnum.Am ? roundAmResults : roundEuResults,
    };

    return results[state.damper].map((value, i) => (value ? (
        <span
            // eslint-disable-next-line react/no-array-index-key
            key={`breadcrumb-value-${i}`}
        >{i > 0 ? ', ' : null} {value}
        </span>
    ) : null));
});
